// src/components/organism/AccountOverview/AccountAdmins/AccountAdmins.tsx
import React from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import { Table } from 'shared-portal-component';

import AccountOverviewCard from '@/components/organism/AccountOverview/AccountOverviewCard/AccountOverviewCard';
import type { AdminUser } from '@/types/organization.types';

interface Props {
  loading?: boolean;
  admins: AdminUser[];
}

const columns: Array<ColumnDef<AdminUser>> = [
  { accessorKey: 'name',  header: 'Admin'  },
  { accessorKey: 'email', header: 'Email'  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ getValue }) => {
      const v = String(getValue());
      const active = v === 'Active';
      return (
        <span className={`inline-block px-4 py-1 rounded-full ${active ? 'bg-green-200' : 'bg-gray-300'}`}>
          {v}
        </span>
      );
    },
  },
];

const AccountAdmins: React.FC<Props> = ({ loading, admins }) => (
  <AccountOverviewCard title="Account Administrators" loading={loading}>
    <Table data={admins} columns={columns} variant="admin" size="sm" />
  </AccountOverviewCard>
);

export default AccountAdmins;
